import {useEffect} from 'react';
import {useMap} from 'react-leaflet';
import L from 'leaflet';

// Warp only the selected, validated planar area; no extrapolation outside its hull.
export default function RegisteredImageOverlay({url,fit,opacity}){
 const map=useMap();
 useEffect(()=>{
  if(!url||!fit)return;
  const canvas=L.DomUtil.create('canvas','solar-registration-overlay');canvas.style.pointerEvents='none';canvas.style.position='absolute';canvas.style.opacity=opacity;
  map.getPane('overlayPane').appendChild(canvas);const img=new Image();let disposed=false;
  const screen=(x,y)=>{const ll=fit.project(x,y);return ll?map.latLngToContainerPoint(ll):null;};
  function triangle(ctx,source,dest){
   if(dest.some(p=>!p))return;
   const [s0,s1,s2]=source,[d0,d1,d2]=dest;
   const a=s1[0]-s0[0],b=s1[1]-s0[1],c=s2[0]-s0[0],d=s2[1]-s0[1],det=a*d-b*c;
   if(Math.abs(det)<1e-10)return;
   const u=d1.x-d0.x,v=d2.x-d0.x,w=d1.y-d0.y,z=d2.y-d0.y;
   const m0=(u*d-v*b)/det,m2=(v*a-u*c)/det,m1=(w*d-z*b)/det,m3=(z*a-w*c)/det;
   ctx.save();ctx.beginPath();ctx.moveTo(d0.x,d0.y);ctx.lineTo(d1.x,d1.y);ctx.lineTo(d2.x,d2.y);ctx.closePath();ctx.clip();
   ctx.transform(m0,m1,m2,m3,d0.x-m0*s0[0]-m2*s0[1],d0.y-m1*s0[0]-m3*s0[1]);ctx.drawImage(img,0,0);ctx.restore();
  }
  function draw(){
   if(disposed||!img.naturalWidth)return;
   const size=map.getSize();canvas.width=size.x;canvas.height=size.y;L.DomUtil.setPosition(canvas,map.containerPointToLayerPoint([0,0]));const ctx=canvas.getContext('2d');
   ctx.save();ctx.beginPath();fit.polygon.forEach(([x,y],i)=>{const p=screen(x,y);if(p){if(i===0)ctx.moveTo(p.x,p.y);else ctx.lineTo(p.x,p.y);}});ctx.closePath();ctx.clip();
   const steps=20;
   for(let y=0;y<steps;y++)for(let x=0;x<steps;x++){
    const p=[[x/steps,y/steps],[(x+1)/steps,y/steps],[(x+1)/steps,(y+1)/steps],[x/steps,(y+1)/steps]];
    const src=p.map(([u,v])=>[u*img.naturalWidth,v*img.naturalHeight]),dst=p.map(([u,v])=>screen(u,v));
    triangle(ctx,[src[0],src[1],src[2]],[dst[0],dst[1],dst[2]]);triangle(ctx,[src[0],src[2],src[3]],[dst[0],dst[2],dst[3]]);
   }ctx.restore();
  }
  img.onload=draw;img.src=url;map.on('moveend zoomend resize',draw);
  return()=>{disposed=true;img.onload=null;map.off('moveend zoomend resize',draw);canvas.remove();};
 },[map,url,fit,opacity]);
 return null;
}
